import { UntypedFormBuilder, Validators } from "@angular/forms";
import { Component, Inject, ViewChild } from "@angular/core";
import { first } from "rxjs/operators";
import { ServiceRequestService } from "@core/services/service-request.service";
import { ReasonDTO } from "../../models/reason-dto";
import { TranslateService } from "@ngx-translate/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { AlertBoxService } from "@core/services";
import { ReasonCancelTypesEnum } from "@shared/enums";

interface PropsType {
  type: string;
}

@Component({
  selector: "app-smartfleet-confirm-reason-modal",
  templateUrl: "./confirm-reason-modal.component.html",
  styleUrls: ["./confirm-reason-modal.component.scss"],
  standalone: false
})
export class ConfirmReasonModalComponent {
  @ViewChild("select") select;
  title = "";
  reasons: ReasonDTO[] = [];
  showTextArea = false;
  isNewLayout = false;

  form = this.fb.group({
    reason: ["", [Validators.required]]
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: PropsType,
    private serviceRequestService: ServiceRequestService,
    private alertBoxService: AlertBoxService,
    private matDialogRef: MatDialogRef<ConfirmReasonModalComponent>,
    private fb: UntypedFormBuilder,
    private translateService: TranslateService
  ) {
    if (this.data.type === ReasonCancelTypesEnum.CANCELLATION) {
      this.title = this.translateService.instant("cancellation-title");
    } else if (this.data.type === ReasonCancelTypesEnum.FLEET_ADMIN_REPROVE) {
      this.title = this.translateService.instant("button-reject-budget");
    } else if (
      this.data.type === ReasonCancelTypesEnum.DONT_CONFIRM_CONCLUSION
    ) {
      this.title = this.translateService.instant("service-not-completed-title");
    }

    this.isNewLayout =
      this.data.type === ReasonCancelTypesEnum.CANCELLATION ||
      this.data.type === ReasonCancelTypesEnum.FLEET_ADMIN_REPROVE;

    this.listCancellationReason();
  }

  listCancellationReason(): void {
    this.serviceRequestService
      .listCancellationReason(this.data.type)
      .pipe(first())
      .subscribe((data) => {
        this.reasons = data;
      });
  }

  selectReason(event: MatSelectChange): void {
    if (event.value.includes("REASON_OTHER")) {
      this.showTextArea = true;
      this.form.addControl(
        "otherReason",
        this.fb.control("", [Validators.required, Validators.minLength(10)])
      );
      this.form.get("otherReason").markAsTouched();
      this.form.get("otherReason").updateValueAndValidity();
      this.select.close();
    } else {
      this.showTextArea = false;
      this.form.removeControl("otherReason");
    }
  }

  closeDialog(isSubmitted: boolean): void {
    if (!isSubmitted) {
      this.matDialogRef.close(null);
      return;
    }

    this.alertBoxService
      .openConfirmationGenericActionAlertBox()
      .afterClosed()
      .pipe(first())
      .subscribe((res) => {
        if (res === "left") {
          const formValue = this.form.getRawValue();
          this.matDialogRef.close({
            ...formValue,
            reason: Array.isArray(formValue.reason)
              ? formValue.reason
              : formValue.reason
              ? [formValue.reason]
              : []
          });
          return;
        }
        this.matDialogRef.close(null);
      });
  }
}
